import baseSvgVue from './base-svg.vue';
import svg2Vue from './svg-2.vue';
import svg6Vue from './svg-6.vue';
export const baseSvg = baseSvgVue;

export const svg2 = svg2Vue;
export const svg6 = svg6Vue;
